class ComponentRegistryService {

    constructor(_) {
        this._ = _;
        this.components = [];
        this.initData = [];
        this.onRegister = null;
        this.onDeRegister = null;
    }

    reset() {
        this.components = [];
    }

    getRegistered() {
        return this.components;
    }

    get(model) {
        return this._.find(this.components, (c) => { return c.modelName === model });
    }

    existsAndValid(model) {
        let matchingQuestion = this.get(model);
        if (matchingQuestion) {
            return matchingQuestion.validState();
        }
        return undefined;
    }

    existWithValue(model, path, valueToCheck) {
        let matchingQuestion = this.get(model);
        if (matchingQuestion) {
            if (this._.isObject(matchingQuestion.model)) {
                return this._.get(matchingQuestion.model, path) === valueToCheck;
            } else {
                return matchingQuestion.model === valueToCheck;
            }
        }
        return undefined;
    }

    setOnRegister(callBack) {
        this.onRegister = callBack;
    }

    setOnDeRegister(callBack) {
        this.onDeRegister = callBack;
    }

    register(component) {
        this.components.push(component);
        this.onRegister(component);
    }

    deregister(component) {
        this._.remove(this.components, (c) =>  c === component);
        this.onDeRegister(component);
    }
    
    static componentRegistryServiceFactory(_) {
        return new ComponentRegistryService(_);
    }
   
}

ComponentRegistryService.componentRegistryServiceFactory.$inject = ['_'];

export default ComponentRegistryService;


// WEBPACK FOOTER //
// ./app/services/component-registry.service.js